export const UK_POSTCODE_PATTERN = /^[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}$/i

export const normalizePostcode = value => {
  const compact = String(value || '').trim().toUpperCase().replace(/\s+/g, '')

  return compact.length > 3
    ? `${compact.slice(0, -3)} ${compact.slice(-3)}`
    : compact
}

export const parsePostcodes = value =>
  Array.from(
    new Set(
      String(value || '')
        .split(/[,;\n]+/)
        .map(normalizePostcode)
        .filter(Boolean)
    )
  )
